/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTDismiss } from './dismiss';
export type { KTDismissConfigInterface, KTDismissInterface } from './types';
